/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_ApprovedInputs */

const en_admin_external_booking_edit_approved = /** @type {(inputs: Admin_External_Booking_Edit_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approved`)
};

const de_admin_external_booking_edit_approved = /** @type {(inputs: Admin_External_Booking_Edit_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigt`)
};

const es_admin_external_booking_edit_approved = /** @type {(inputs: Admin_External_Booking_Edit_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprobada`)
};

const fr_admin_external_booking_edit_approved = /** @type {(inputs: Admin_External_Booking_Edit_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approuvée`)
};

const nl_admin_external_booking_edit_approved = /** @type {(inputs: Admin_External_Booking_Edit_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goedgekeurd`)
};

/** @type {(inputs: Admin_External_Booking_Edit_ApprovedInputs) => LocalizedString} */
const it_admin_external_booking_edit_approved = en_admin_external_booking_edit_approved;

/** @type {(inputs: Admin_External_Booking_Edit_ApprovedInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_approved = en_admin_external_booking_edit_approved;

/** @type {(inputs: Admin_External_Booking_Edit_ApprovedInputs) => LocalizedString} */
const pl_admin_external_booking_edit_approved = en_admin_external_booking_edit_approved;

/** @type {(inputs: Admin_External_Booking_Edit_ApprovedInputs) => LocalizedString} */
const hu_admin_external_booking_edit_approved = en_admin_external_booking_edit_approved;

/** @type {(inputs: Admin_External_Booking_Edit_ApprovedInputs) => LocalizedString} */
const ro_admin_external_booking_edit_approved = en_admin_external_booking_edit_approved;

/**
* | output |
* | --- |
* | "Approved" |
*
* @param {Admin_External_Booking_Edit_ApprovedInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_approved = /** @type {((inputs?: Admin_External_Booking_Edit_ApprovedInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_ApprovedInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_approved(inputs)
	if (locale === "de") return de_admin_external_booking_edit_approved(inputs)
	if (locale === "es") return es_admin_external_booking_edit_approved(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_approved(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_approved(inputs)
	if (locale === "it") return it_admin_external_booking_edit_approved(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_approved(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_approved(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_approved(inputs)
	return ro_admin_external_booking_edit_approved(inputs)
});
export { admin_external_booking_edit_approved as "admin.external_booking_edit.approved" }